import { render, staticRenderFns } from "./VideoRankSelect.vue?vue&type=template&id=412c86a0&scoped=true"
import script from "./VideoRankSelect.vue?vue&type=script&lang=js"
export * from "./VideoRankSelect.vue?vue&type=script&lang=js"
import style0 from "./VideoRankSelect.vue?vue&type=style&index=0&id=412c86a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c86a0",
  null
  
)

export default component.exports